'use server';

import { currentUser } from '@clerk/nextjs/server';
import { syncUser } from '@/lib/agents';

export async function syncUserAction(): Promise<void> {
  const user = await currentUser();
  if (!user) return;
  const email = user.emailAddresses[0]?.emailAddress;
  const name = [user.firstName, user.lastName].filter(Boolean).join(' ') || undefined;
  await syncUser(user.id, email, name).catch(() => {});
}
